import moment from 'moment-timezone';
import { MyAvailability } from './MyAvailability';
export default class MyAvailabilityDay {
    constructor(day, hours, id) {
        this.hours = [];
        this.overlapIndex = 0;
        this.day = day;
        this.id = id || '';
        this.hours = hours || [
            {
                startTime: '8:0',
                endTime: '17:0',
            },
        ];
    }
    addNewAvailabilityHourWithStartTimeAndEndTime({ startTime, endTime, copy, }) {
        if ((!startTime && !endTime) || this.hours.length === 0) {
            this.hours.push({
                startTime: '8:0',
                endTime: '17:0',
            });
        }
        else if (!copy) {
            const lastHour = this.getLastHour();
            this.hours.push({
                startTime: moment(lastHour.endTime, 'H:m').add(1, 'hour').format('H:m'),
                endTime: moment(lastHour.endTime, 'H:m').add(2, 'hour').format('H:m'),
            });
        }
        this.updateOverlapIndex();
    }
    getLastHour() {
        if (this.hours.length === 0) {
            return { startTime: null, endTime: null };
        }
        return this.hours[this.hours.length - 1];
    }
    removeAvailabilityHour(index) {
        this.hours.splice(index, 1);
        this.updateOverlapIndex();
    }
    removeAllAvailabilityHour() {
        this.hours.splice(0);
    }
    updateOverlapIndex() {
        const overlapIndexes = this.getOverlappingHours();
        this.overlapIndex = overlapIndexes.length;
    }
    getOverlappingHours() {
        const overlaps = [];
        if (this.hours.length <= 1) {
            return overlaps;
        }
        for (let i = 0; i < this.hours.length - 1; i++) {
            for (let j = i + 1; j < this.hours.length; j++) {
                const startTime1 = moment(this.hours[i].startTime, 'H:mm');
                const endTime1 = moment(this.hours[i].endTime, 'H:mm');
                const startTime2 = moment(this.hours[j].startTime, 'H:mm');
                const endTime2 = moment(this.hours[j].endTime, 'H:mm');
                if (startTime1.isBetween(startTime2, endTime2) ||
                    endTime1.isBetween(startTime2, endTime2) ||
                    startTime2.isBetween(startTime1, endTime1) ||
                    endTime2.isBetween(startTime1, endTime1)) {
                    overlaps.push(i);
                    overlaps.push(j);
                }
            }
        }
        return [...new Set(overlaps)];
    }
    isOverlapIndex(hourIndex) {
        const overlapIndexes = this.getOverlappingHours();
        return Math.max(...overlapIndexes) === hourIndex;
    }
    get dayOfWeek() {
        var _a, _b;
        return (_b = (_a = MyAvailability.DAYS.find(day => day.name === this.day)) === null || _a === void 0 ? void 0 : _a.index) !== null && _b !== void 0 ? _b : -1;
    }
    get serializeHours() {
        return this.hours
            .map(hour => {
            if (!hour.startTime || !hour.endTime) {
                return null;
            }
            const [openHour, openMinute] = hour.startTime.split(':').map(Number);
            const [closeHour, closeMinute] = hour.endTime.split(':').map(Number);
            return {
                open_hour: openHour,
                open_minute: openMinute,
                close_hour: closeHour,
                close_minute: closeMinute,
            };
        })
            .filter(Boolean);
    }
    get serializeHoursAsPerAPIFormat() {
        return this.hours
            .map(hour => {
            if (!hour.startTime || !hour.endTime) {
                return null;
            }
            const [openHour, openMinute] = hour.startTime.split(':').map(Number);
            const [closeHour, closeMinute] = hour.endTime.split(':').map(Number);
            return {
                openHour,
                openMinute,
                closeHour,
                closeMinute,
            };
        })
            .filter(Boolean);
    }
    get hasAnyErrorHours() {
        return this.hoursErrorMapping.some(x => x);
    }
    get hoursErrorMapping() {
        return this.hours.map(hour => this.isInvalidStartEndTime(hour));
    }
    isInvalidStartEndTime(hours) {
        if (!(hours === null || hours === void 0 ? void 0 : hours.startTime) || !(hours === null || hours === void 0 ? void 0 : hours.endTime)) {
            return true;
        }
        const midnight = moment('00:00:00', 'HH:mm:ss');
        const startDateTime = moment(hours.startTime, 'hh:mm:ss A');
        const endDateTime = moment(hours.endTime, 'hh:mm:ss A');
        if (startDateTime.isSame(midnight) && endDateTime.isSame(midnight)) {
            return false; // start time end time selected as 12:00 AM
        }
        return startDateTime.isAfter(endDateTime);
    }
}
